<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="december">
<h1>December</h1>
<p style="text-indent:0px;">The last month of the year?</p>
<p style="text-indent:0px;">Already, time flies!</p>
<p style="text-indent:0px;">Put a hold on your career,</p>
<p style="text-indent:0px;">Soon you shall unwrap a surprise!</p><br/>
<p style="text-indent:0px;">The countdown to Christmas,</p>
<p style="text-indent:0px;">And the New Year too.</p>
<p style="text-indent:0px;">Holidays at golden beaches?</p>
<p style="text-indent:0px;">Another year you’ve got through.</p><br/>
<p style="text-indent:0px;">The kids are excited,</p>
<p style="text-indent:0px;">Time slows down, indeed!</p>
<p style="text-indent:0px;">Their holiday’s extended,</p>
<p style="text-indent:0px;">As from school they are freed!</p><br/>
<p style="text-indent:0px;">It snows in the North,</p>
<p style="text-indent:0px;">A soft blanket of white.</p>
<p style="text-indent:0px;">It’s hot in the South,</p>
<p style="text-indent:0px;">But that too is alright!</p><br/>
<p style="text-indent:0px;">Get some sherry to sip,</p>
<p style="text-indent:0px;">It’s almost time for a feast!</p>
<p style="text-indent:0px;">Please take on this tip,</p>
<p style="text-indent:0px;">Remember those with the least.</p><br/>
<p style="text-indent:0px;">Whatever toys you don’t want,</p>
<p style="text-indent:0px;">Wrap up for the poor!</p>
<p style="text-indent:0px;">Every child deserves to chant,</p>
<p style="text-indent:0px;">“Hooray! Santa put gifts on our floor!”</p><br/>
<p style="text-indent:0px;">The season of compassion,</p>
<p style="text-indent:0px;">Has crept up its true!</p>
<p style="text-indent:0px;">So make it your mission,</p>
<p style="text-indent:0px;">To be grateful, and genuine too.</p><br/>
<p style="text-indent:0px;">Spread love where it is needed,</p>
<p style="text-indent:0px;">Give what you can.</p>
<p style="text-indent:0px;">Everyone must be treated,</p>
<p style="text-indent:0px;">With the kindness of man.</p><br/>
<p style="text-indent:0px;">Look forward, as a new year is nearby,</p>
<p style="text-indent:0px;">You will be joyful and merry, of this I don’t doubt!</p>
<p style="text-indent:0px;">Let us be considerate, as it goes by,</p>
<p style="text-indent:0px;">Embrace what this season is all about.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?40315e27